import { Button, Dropdown, Input, Radio } from "antd";
import { RadioChangeEvent } from "antd/lib/radio";
import ctx from "classnames";
import React, { FunctionComponent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCompanies } from "../../features/company/companySlice";
import {
  fetchGroups,
  selectGroups,
} from "../../features/groups/groupSlice";
import styles from "./shared.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import { getTranslations } from "../../features/translations/translationsUtils";

interface CompanyFilteMenuProps {
  closeMenu: Function;
  onApply: React.Dispatch<React.SetStateAction<(string | number)[]>> | ((value: string) => void);
  value?: string;
}
const FilterMenu: FunctionComponent<CompanyFilteMenuProps> = ({
  onApply,
  closeMenu,
  value,
}) => {
  const [selectedCompanyId, setValue] = useState<string>(value ?? "");
  const [filterCompanyText, setFilterCompanyTextValue] = useState<string>("");
  const companiesDict = useSelector(selectCompanies);
  const groups = useSelector(selectGroups);
  const dispatch = useDispatch();
  const plainOptions = Object.keys(companiesDict)
    .map((companyId) => ({
      label: companiesDict[companyId].name,
      value: companyId,
    }))
    .filter((company) => {
      const textToSeach = (filterCompanyText.toLowerCase() || "").trim();
      if (!textToSeach) {
        return true;
      }
      return company.label.toLowerCase().includes(textToSeach);
    });
  const onChange = (e: RadioChangeEvent) => {
    const companyId = e.target.value;
    if (companyId) {
      setValue(companyId || "");
    }
  };
  const onApplyFilter = () => {
    const filters: string[] = [];
    if (selectedCompanyId !== "") {
      filters.push(selectedCompanyId);
    }
    // @ts-ignore
    onApply(selectedCompanyId);
    closeMenu();
  };
  const onClearFilter = () => {
    // @ts-ignore
    onApply("");
    closeMenu();
    setValue("");
    setFilterCompanyTextValue("");
  };

  useEffect(() => {
    if (groups.length === 0) {
      dispatch(fetchGroups());
    }
  }, [groups, dispatch]);

  return (
    <div className={styles.filterMenu}>
      <div className={styles.wrapper}>
        <div className={styles.innerContainer}>
          <div className={styles.inpuntContainer}>
            <Input
              prefix={<SearchOutlined className='search-icon' />}
              className={ctx(styles.search, styles.wrapper, 'custom-search')}
              onChange={(event) => {
                setFilterCompanyTextValue(event.target.value)
              }}
            />
          </div>
          {
            <Radio.Group
              className={ctx(styles.radioGroup, styles.vertical)}
              options={plainOptions}
              onChange={onChange}
              value={selectedCompanyId}
            />
          }
        </div>
      </div>
      <div className={styles.actionButton}>
        <Button
          disabled={!selectedCompanyId}
          type="link"
          onClick={onClearFilter}
        >
          {getTranslations('COMPANY_FILTER_CLEAR')}
          
        </Button>
        <Button type="link" onClick={onApplyFilter}>
          {getTranslations('COMPANY_FILTER_APPLY')}
        </Button>
      </div>
    </div>
  );
};
interface CompanyFilterProps {
  type?: "report";
  reset?: boolean;
  onApply: React.Dispatch<React.SetStateAction<(string | number)[]>> | ((value: string) => void);
  value?: string;
}

export const CompanyFilter: FunctionComponent<CompanyFilterProps> = ({
  type,
  onApply,
  reset,
  value,
}) => {
  const [visible, setVisible] = useState<boolean>(false);
  const companiesDict = useSelector(selectCompanies);

  useEffect(() => {
    if (reset) {
      // setCompanyIds([]);
    }
  }, [reset]);

  const getFilterLabel = (): string => {
    if (!type) {
      return getTranslations('COMPANY_FILTER_TITLE');
    }
    if (value) {
      return companiesDict[value ?? '']?.name ?? "";
    }
    return getTranslations('COMPANY_FILTER_TITLE');
  };

  const getClassName = (): string => {
    if (!type) {
      return styles.filterButton;
    }
    if (value) {
      return ctx(styles.filterButton, styles.company);
    }
    return ctx(styles.filterButton, styles.report);
  };

  // useEffect(() => {
  //   // onApply(companyIds);
  // }, [value, onApply]);

  return (
    <Dropdown
      overlay={
        !reset ? (
          <FilterMenu
            closeMenu={() => setVisible(false)}
            onApply={onApply}
            value={value}
          />
        ) : (
          <></>
        )
      }
      trigger={["click"]}
      onVisibleChange={(visible) => setVisible(visible)}
      visible={visible}
    >
      <div className={getClassName()}>
        <div className={styles.filterIcon}>
          <div className={styles.filterIconTopLine} />
          <div className={styles.filterIconBottomLine} />
        </div>
        {getFilterLabel()}
      </div>
    </Dropdown>
  );
};
